import { apiClient } from './client'

// Types
export interface AccessRequestCreate {
  requested_kbs: string[]
  reason: string
}

export interface AccessRequestResponse {
  request_id: number
  status: string
}

export interface PendingRequestInfo {
  id: number
  user_email: string
  user_name: string
  requested_kbs: string[]
  reason: string
  requested_at: string
  status: string
}

export interface MyAccessRequestStatus {
  has_pending_request: boolean
  pending_request: PendingRequestInfo | null
}

// Access Request API service (for users without access)
export const accessRequestApi = {
  // Get available knowledge bases for request form (no role check)
  async getKnowledgeBasesForRequest(): Promise<string[]> {
    const response = await apiClient.get('/v1/users/kbs-for-request')
    return response.data
  },

  // Check if current user has a pending request
  async getMyRequestStatus(): Promise<MyAccessRequestStatus> {
    const response = await apiClient.get('/v1/users/my-request-status')
    return response.data
  },

  // Submit access request
  async submitRequest(request: AccessRequestCreate): Promise<AccessRequestResponse> {
    const response = await apiClient.post('/v1/users/request-access', request)
    return response.data
  },
}

export default accessRequestApi
